import { Box, Stack, StackProps, Button } from '@mui/material';
import { ReactComponent as PlusIcon } from '../../../assets/plus-icon.svg';
import { useTheme } from '@mui/material/styles';

type CreateProgramCardProps = {
  onClickCreateProgram?: (event: any) => void;
  bgColor?: string;
  containerProps?: StackProps;
};

const CreateProgramCard = ({
  onClickCreateProgram,
  bgColor,
  containerProps,
}: Readonly<CreateProgramCardProps>) => {
  const theme = useTheme();
  const colors = theme.palette;

  const resolvedBgColor = bgColor ?? colors.widget.background.card;

  return (
    <Box display="flex" flexGrow={1} height="100%" width="100%" position="relative">
      <Stack
        minHeight="100px"
        p={2}
        bgcolor={resolvedBgColor}
        fontFamily="Montserrat"
        borderRadius="5px"
        flexGrow={1}
        width="90%"
        {...containerProps}
        sx={{
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
          ...containerProps?.sx,
        }}
      >
        <Stack width="100%">
          <Button
            variant="pepwiseButtonText"
            startIcon={<PlusIcon />}
            sx={{
              alignSelf: 'flex-start',
              pl: 0,
              pr: 2,
              minWidth: 'auto',
              borderRadius: '8px',
              color: colors.widget.text.action.primary,
              '& .MuiButton-startIcon': {
                marginRight: '6px',
                marginLeft: 0,
              },
              '& svg path': {
                fill: colors.widget.text.action.primary,
              },
            }}
            onClick={onClickCreateProgram}
          >
            CREATE NEW PROGRAM
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};

export default CreateProgramCard;
